
import loadAccessibleMarkerGroupClass from './load-accessible-marker-group';


import { keys } from '../../00-base/global/utils/keycodes';
import announce from '../../00-base/global/utils/announce';
import debounce from '../../00-base/global/utils/debounce';
import MarkerIndex from './marker-index';

window.cmhr = window.cmhr || {};
window.cmhr.dynamic = window.cmhr.dynamic || {};

/* global u, google */

/**
 * Initializes the google map
 * @return {[type]} [description]
 */

const initMap = function() {

    const AccessibleMarkerGroup = loadAccessibleMarkerGroupClass(window.cmhr.dynamic);


    // https://snazzymaps.com/editor/customize/15
    const map_style = [
        // {
        //     'featureType': 'administrative',
        //     'elementType': 'all',
        //     'stylers': [
        //         {
        //             'saturation': '-100'
        //         }
        //     ]
        // },
        {
            'featureType': 'administrative.province',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        // {
        //     'featureType': 'landscape',
        //     'elementType': 'all',
        //     'stylers': [
        //         {
        //             'saturation': -100
        //         },
        //         {
        //             'lightness': 65
        //         },
        //         {
        //             'visibility': 'on'
        //         }
        //     ]
        // },
        // {
        //     'featureType': 'poi',
        //     'elementType': 'all',
        //     'stylers': [
        //         {
        //             'saturation': -100
        //         },
        //         {
        //             'lightness': '50'
        //         },
        //     ]
        // },
        {
            'featureType': 'poi.business',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        // {
        //     'featureType': 'road',
        //     'elementType': 'all',
        //     'stylers': [
        //         {
        //             'saturation': '-100'
        //         }
        //     ]
        // },
        {
            'featureType': 'road.highway',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        }
        // {
        //     'featureType': 'road.arterial',
        //     'elementType': 'all',
        //     'stylers': [
        //         {
        //             'lightness': '30'
        //         }
        //     ]
        // },
        // {
        //     'featureType': 'road.local',
        //     'elementType': 'all',
        //     'stylers': [
        //         {
        //             'lightness': '40'
        //         }
        //     ]
        // },
        // {
        //     'featureType': 'transit',
        //     'elementType': 'all',
        //     'stylers': [
        //         {
        //             'saturation': -100
        //         },
        //         {
        //             'visibility': 'simplified'
        //         }
        //     ]
        // },
        // {
        //     'featureType': 'water',
        //     'elementType': 'geometry',
        //     'stylers': [
        //         {
        //             'hue': '#ffff00'
        //         },
        //         {
        //             'lightness': -25
        //         },
        //         {
        //             'saturation': -97
        //         }
        //     ]
        // },
        // {
        //     'featureType': 'water',
        //     'elementType': 'labels',
        //     'stylers': [
        //         {
        //             'lightness': -25
        //         },
        //         {
        //             'saturation': -100
        //         }
        //     ]
        // }
    ];



    let maps = u('.js-custom-gmap');

    const default_options = {
        styles: map_style
    };
 

    const gmaps = maps.nodes.map((node, mapIndex) => {
   
        let options = default_options;

        const mapId = `map-${mapIndex}`;

        // If static map, update the options to prevent user interactions.
        if (node.getAttribute('data-type') === 'static') {
            options = Object.assign(options, {
                disableDefaultUI: true,
                draggable: false,
                scrollwheel: false,
                panControl: false,
            });
        } else {
            options = Object.assign(options, {
                panControl: true,
                zoomControl: true,
                tiltControl: false,
                rotateControl: false,
                keyboardShortcuts: true
            })
        }

        // Get the map center.

        const center = { lat: parseFloat(node.getAttribute('data-center-lat')), lng: parseFloat(node.getAttribute('data-center-lng')) };
        const zoomStr = node.getAttribute('data-zoom-level');
        options = Object.assign(options, {
            center: center,
            zoom: zoomStr ? parseInt(zoomStr) : 16,
            clickableIcons: false,
            fullscreenControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            rotateConrol: false
        });


        // Create the map.
        const map = new google.maps.Map(node, options);
        const parentEl = node.closest('.js-custom-map-wrapper');

        const labelledById = node.dataset.nearestHeadingId;

        let mapContainer = null;
   
        google.maps.event.addListenerOnce(map, 'idle', e => {
            mapContainer = node.querySelector('.gm-style > *[tabindex="0"]');
            if (mapContainer) {
                if (labelledById) {
                    mapContainer.setAttribute('aria-labelledby', labelledById);
                    mapContainer.setAttribute('role', 'application');
                }

                mapContainer.addEventListener('focus', e => {
                    node.classList.add('main-focused');
                });

                
                mapContainer.addEventListener('blur', e => {
                    node.classList.remove('main-focused');
                })

                
            }
        });

        //Google maps sometimes does not include empty alt text for image buttons. Add.
        const cleanUpImageAlts = () => {
            const unlabelledImgs = node.querySelectorAll('img:not([alt])');
            Array.from(unlabelledImgs).forEach(img => {
                img.setAttribute('alt', '')
                img.setAttribute('aria-hidden', 'true');
            });
        }

        let firstPostMarkerElement = null;
        function getFirstPostMarkerEl() {
            if (!firstPostMarkerElement) {
                firstPostMarkerElement = node.querySelector('.js-custom-gmap iframe+div a');
            }

            return firstPostMarkerElement;
        }


        const onMapMutation = () => {
            cleanUpImageAlts();
        }
        
        onMapMutation();

        const addedImgObserver = new MutationObserver(onMapMutation);
        addedImgObserver.observe(node, {
            childList: true,
            subtree: true
        });

        const directionsService = new google.maps.DirectionsService();
        const directionsRenderer = new google.maps.DirectionsRenderer({suppressMarkers: true, suppressInfoWindows: true, preserveViewport: true});

        directionsRenderer.setMap(map);

        // Add marker/s.

        const headingLevel = parseInt(node.dataset.mapHeadingLevel);
        const contentLabels = JSON.parse(node.dataset.contentLabels);

        //get marker types (json-encoded)
        const markerTypes = JSON.parse(node.dataset.markerTypes);
        
        // Get data-markers (json-encoded).
        const markers = JSON.parse(node.dataset.markers);
 
        
        

        let positionMarker = null;

        const createPositionMarker = function(position) {
            return new google.maps.Marker({
                position: position, clickable: false,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 10,
                    fillColor: '#232323',
                    fillOpacity: 1,
                    strokeWeight: 2,
                    strokeColor: '#FFFFFF'
                },

            });
        }

        map.defaultPadding = {top: 40, left: 20, right: 40, bottom: 40};

        map.getOverlayPadding = function() {
            if (map.currentPopup) {
                return map.currentPopup.getOverlayPadding();
            } else {
                return map.defaultPadding;
            }
        }

        map.getPaddingAdjustedBounds = function() {
            const padding = map.getOverlayPadding();
            const pxRect = node.getBoundingClientRect();

            const projection = map.getProjection();

            return new google.maps.LatLngBounds(
                projection.fromPointToLatLng(pxRect.height - padding.bottom, padding.left),
                projection.fromPointToLatLng(padding.top, pxRect.width - padding.right)
            );

        }

        const updatePositionMarker = function(position) {
            const newPosition = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };

            if (!positionMarker) {
                positionMarker = createPositionMarker(newPosition);
                positionMarker.setMap(map);

            } else {
                positionMarker.setPosition(newPosition);
            }

            map.fitBounds({
                west: Math.min(map.markerBounds.west, newPosition.lng),
                east: Math.max(map.markerBounds.east, newPosition.lng),
                north: Math.max(map.markerBounds.north, newPosition.lat),
                south: Math.min(map.markerBounds.south, newPosition.lat)
            }, map.getOverlayPadding());
        };

        let markerInd = null;
        function getMarkerIndex() {

            if (!markerInd) {
                markerInd = new MarkerIndex(map.markerGroups);
            }
            return markerInd;
        }

        const getMarkerGroups = function() {
            return Object.keys(markerTypes).map(k => {
                const markerType = markerTypes[k];
              

                markerType.markerTypeId = k;

                const mapData = {
                    map: map,
                    mapId: mapId,
                    mapIndex: mapIndex,
                    mapLang: node.dataset.mapLang,
                    headingLevel: headingLevel,
                    contentLabels: contentLabels
                }
                return new AccessibleMarkerGroup(markers.filter(m => m.typeId == k), markerType, map, mapData, directionsService, directionsRenderer, updatePositionMarker, node);
            })
        }

        map.markerGroups = getMarkerGroups();
        map.markerOverlays = {}; //markers && markers instanceof Array ? getMarkerOverlays(markers) : [] ;
        map.markerGroups.forEach(g => g.markers_.forEach(m => {map.markerOverlays[m.id_] = m;}));
        map.allMarkers = Object.keys(map.markerOverlays).map(k => map.markerOverlays[k]);

  

        const lats = markers.map(m => m.position.lat);
        const lngs = markers.map(m => m.position.lng);

    
        map.markerBounds ={
            west: Math.min(...lngs),
            east: Math.max(...lngs),
            north: Math.max(...lats),
            south: Math.min(...lats)
        }

        map.fitBounds(map.markerBounds, map.getOverlayPadding());
        

        const findMeButton = node.parentElement.querySelector('.js-btn-find-me');
        if (findMeButton && navigator.geolocation) {
            findMeButton.addEventListener('click', (e) => {
                announce(contentLabels.locationLoadingText);
                parentEl.classList.remove('has-top-level-error');
                navigator.geolocation.getCurrentPosition((position) => {
                    updatePositionMarker(position);
                    announce(contentLabels.locationLoadedText);
                    parentEl.classList.remove('has-top-level-error');
                }, (e) => {
                    parentEl.classList.add('has-top-level-error');
                    announce(`${contentLabels.errorText} ${contentLabels.noLocationMessageTextFindMe}`);
                    console.log(e);
                })
            });
        }

        const centerMarkersButton = node.parentElement.querySelector('.js-btn-center-markers');
        if (centerMarkersButton) {
            centerMarkersButton.addEventListener('click', e => {
                map.fitBounds(map.markerBounds, map.getOverlayPadding());
                announce(contentLabels.mapUpdatedText);
            })
        }

     

        function getNextMarker(isReverse) {
            if (!document.activeElement) {
                return null;
            }

            const markerIndex = getMarkerIndex();
            const id = document.activeElement.id;

            if (!isReverse) { 
                if (document.activeElement == mapContainer) {
                    return markerIndex.byIndex[0];
                } else {
                    return markerIndex.getNextMarker(id);
                }
            } else {
                if (document.activeElement == getFirstPostMarkerEl()) {
                    const lastMarker = markerIndex.byIndex[markerIndex.lastItemIndex];
                    return lastMarker.isOpen_ ? null : lastMarker;
                } else {
                    return markerIndex.getPrevMarker(id);
                }
            }
        }



        function centerMap() {
            if (window.cmhr.documentScroller) {


                const alignment = 'bottom';
                window.cmhr.documentScroller.scrollToElement(node, alignment);
                return true;
            }

            return false;
        }
        
        node.addEventListener('keydown', e => {

            if (e.keyCode === keys.tab) {
                const marker = getNextMarker(e.shiftKey);

                if (marker) {

          
                    const markerElement = marker.markerButton_;


                    if (!marker.isWithinBounds()) {
                        google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
                            google.maps.event.addListenerOnce(map, 'idle', () => markerElement.focus());
                        });

                        map.fitBounds(map.markerBounds, map.getOverlayPadding());

                        e.preventDefault();
                        e.stopImmediatePropagation();
                        e.stopPropagation();
                    }
                }

                centerMap();
            }

        });

        const instructions = {};
        instructions[keys.up] = contentLabels.movingNorthText;
        instructions[keys.down] = contentLabels.movingSouthText;
        instructions[keys.left] = contentLabels.movingWestText;
        instructions[keys.right] = contentLabels.movingEastText;
        instructions[187] = contentLabels.zoomingInText;
        instructions[189] = contentLabels.zoomingOutText;
        instructions[107] = contentLabels.zoomingInText;
        instructions[109] = contentLabels.zoomingOutText;



        node.addEventListener('keyup', e => {
            if (e.keyCode in instructions && document.activeElement == mapContainer) {
       
                announce(instructions[e.keyCode]);
            }
        });

        
        delete node.dataset.waitingForMapInit;

        return map;
    });

    window.addEventListener('resize', debounce(() => {
        gmaps.filter(map => map.currentPopup).forEach(map => map.currentPopup.positionPopupSingle());
    }))
};



window.initMap = initMap;


const insertCustomMap = function(documentScroller) {
    window.cmhr.documentScroller = documentScroller;
   if (document.querySelector('[data-waiting-for-map-init]')) {
       initMap();
   }
} 


 
export default insertCustomMap;